var _defs, _g, _path, _line, _path2, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 625.42 418.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d,.e{fill:none;}.b{clip-path:url(#a);}.c,.d,.e{stroke:#fc4c02;stroke-linecap:round;stroke-linejoin:round;}.c,.d{stroke-width:10.11px;}.d{stroke-dasharray:19.8 29.71;}.e{stroke-width:10px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-0.29 -86.47)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 172.54,
    y: 220.7,
    width: 216,
    height: 286.59,
    transform: "translate(-102.44 109.98) rotate(-18.82)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.59,308.15l-.38.13a22,22,0,0,0-12.27,10.17c-6.09-7.61-16.18-11.12-25.5-7.95a22.44,22.44,0,0,0-12.92,11.67A22.88,22.88,0,0,0,276,316.4l-.4.14a20.91,20.91,0,0,0-11,8.39l-17.91-52.55c-4.33-12.69-17.74-19.66-29.76-15.56s-18.33,17.77-14,30.47l35.44,104.28-8.35-5.15a31.45,31.45,0,0,0-24.79-3.88,30.93,30.93,0,0,0-19.29,15.24l-3.68,6a4.81,4.81,0,0,0,.77,6l82.62,78.93c15.1,14.42,36.19,19.44,55,13l56.25-19.17,0-.05c28.52-9.72,43.21-42.35,32.88-72.75-4.62-13.6-8.13-23.71-10.92-31.93-7.46-22-10.25-30.08-18.55-54.27-4.35-12.66-17.64-19.51-29.63-15.42Zm39,72.79c2.79,8.22,6.24,18.4,10.86,32,8.63,25.37-3.47,52.58-27,60.59l-56,19.08c-15.41,5.26-32.76,1.06-45.25-10.87l-79.79-76.21,1.7-2.79.12-.22a21.4,21.4,0,0,1,13.35-10.65,21.85,21.85,0,0,1,17.24,2.75l19.76,12.24a4.82,4.82,0,0,0,7.11-5.65l-39.8-117c-2.6-7.67,1.06-15.87,8.05-18.25s14.91,1.88,17.52,9.54l24,70.54c.09.24.16.5.25.74a3,3,0,0,0,.12.32l10.28,30.16a4.82,4.82,0,1,0,9.12-3.11L270.7,343.07c-2.52-7.39,1.16-15.09,8-17.41l.4-.14c7-2.38,14.89,1.73,17.5,9.39l9.41,27.6a4.82,4.82,0,0,0,9.13-3.11l-7.38-21.65c-2.62-7.67.8-15.79,7.83-18.19s14.65,2,17.26,9.63l7,20.43a4.82,4.82,0,1,0,9.12-3.11l-3.77-11.06c-2.61-7.67,1.19-15.66,8.18-18l.38-.13c7-2.38,14.74,1.78,17.36,9.42,8.3,24.17,11.05,32.27,18.51,54.24Zm0,0",
    transform: "translate(-0.29 -86.47)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189,294.21a4.83,4.83,0,0,0,3-6.12,33.41,33.41,0,0,1,63.24-21.56,4.82,4.82,0,1,0,9.12-3.11A43,43,0,0,0,182.9,291.2a4.82,4.82,0,0,0,6.12,3Zm0,0",
    transform: "translate(-0.29 -86.47)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 203.19,
    y1: 386.17,
    x2: 193.43,
    y2: 388.82
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M165.05,483.07l-60.22,16.35a5.67,5.67,0,0,1-7-4L5.54,155.27a5.67,5.67,0,0,1,4-7L218,91.72a5.69,5.69,0,0,1,7,4l32.83,115.15",
    transform: "translate(-0.29 -86.47)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 261.59,
    y1: 138.67,
    x2: 264.36,
    y2: 148.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M395.71,302.24v-205a5.68,5.68,0,0,1,5.67-5.67H615a5.68,5.68,0,0,1,5.67,5.67V445.85a5.68,5.68,0,0,1-5.67,5.67H432.52",
    transform: "translate(-0.29 -86.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.12b3ddc4acf1e6ab6740451535b334e0.svg";
export { ForwardRef as ReactComponent };